var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizeTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.698,
    height: 28.698,
    viewBox: "0 0 28.698 28.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14485",
    "data-name": "Group 14485",
    transform: "translate(-1476.706 -156.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14477",
    "data-name": "Group 14477",
    transform: "translate(-43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14474",
    "data-name": "Group 14474",
    transform: "translate(1519.706 156.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13136",
    "data-name": "Group 13136",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 14.349,
    cy: 14.349,
    r: 14.349,
    fill: "currentColor"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14484",
    "data-name": "Group 14484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14483",
    "data-name": "Group 14483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14482",
    "data-name": "Group 14482",
    transform: "translate(2845.786 -1128.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14478",
    "data-name": "Group 14478",
    transform: "translate(-1363.286 1292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8063",
    "data-name": "Path 8063",
    d: "M-1347.445,1294.537h-14.572a1.269,1.269,0,0,1-1.269-1.269,1.269,1.269,0,0,1,1.269-1.269h14.572a1.269,1.269,0,0,1,1.269,1.269A1.269,1.269,0,0,1-1347.445,1294.537Z",
    transform: "translate(1363.286 -1292)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14479",
    "data-name": "Group 14479",
    transform: "translate(-1363.286 1296.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8064",
    "data-name": "Path 8064",
    d: "M-1347.445,1460.251h-14.572a1.269,1.269,0,0,1-1.269-1.269,1.269,1.269,0,0,1,1.269-1.269h14.572a1.269,1.269,0,0,1,1.269,1.269A1.269,1.269,0,0,1-1347.445,1460.251Z",
    transform: "translate(1363.286 -1457.714)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14480",
    "data-name": "Group 14480",
    transform: "translate(-1363.286 1300.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8065",
    "data-name": "Path 8065",
    d: "M-1347.445,1625.966h-14.572a1.269,1.269,0,0,1-1.269-1.269,1.269,1.269,0,0,1,1.269-1.269h14.572a1.269,1.269,0,0,1,1.269,1.269A1.269,1.269,0,0,1-1347.445,1625.966Z",
    transform: "translate(1363.286 -1623.429)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14481",
    "data-name": "Group 14481",
    transform: "translate(-1363.286 1304.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8066",
    "data-name": "Path 8066",
    d: "M-1347.445,1785.966h-14.572a1.269,1.269,0,0,1-1.269-1.269,1.269,1.269,0,0,1,1.269-1.269h14.572a1.269,1.269,0,0,1,1.269,1.269A1.269,1.269,0,0,1-1347.445,1785.966Z",
    transform: "translate(1363.286 -1783.429)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizeTable);
export default __webpack_public_path__ + "static/media/organize-table.45aae696f9805eee50ca391f95342afe.svg";
export { ForwardRef as ReactComponent };